module.exports = __webpack_public_path__ + "static/media/fly0202.32a4b39e.webp";